// extracted by mini-css-extract-plugin
export default {"container":"QVFPXBryIpMGbgwgpZS1","title":"q3iB_HhS6OOhFztOyJ7t"};